import { FC, ReactNode } from "react";
import { Layout, Menu } from "antd";
import { ContentLayout, WrapperLayout, WrapperSider } from "./styled";
import { NavBar } from "../ui";
import { useAdminMenuLayout } from "./hooks";
import { ChevronLeft } from "lucide-react";

const { Content } = Layout;
interface Props {
  children: ReactNode;
  title: string;
  pageDescription: string;
}

export const AdminMenuLayout: FC<Props> = ({
  children,
  title: _title,
  pageDescription: _pageDescription,
}) => {
  const { collapsed, items, pathname, changeCollapsed } = useAdminMenuLayout();
  return (
    <WrapperLayout>
      <NavBar collapsed={collapsed} title={_title} />
      <ContentLayout>
        <WrapperSider
          theme="light"
          collapsedWidth="80"
          collapsible
          collapsed={collapsed}
          width={260}
          trigger={null}
          onCollapse={(collapsed, type) => {
            console.log(collapsed, type);
          }}
        >
          <div 
            style={{
              padding: "16px 20px",
              borderBottom: "1px solid #f0f0f0",
              height: "64px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "12px"
            }}
          >
            <img
              src={collapsed ? "/logo-cerrado.png" : "/logo-sushi2gon.png"}
              alt="Sushi 2 Go"
              onClick={changeCollapsed}
              style={{
                height: collapsed ? "32px" : "40px",
                objectFit: "contain",
                transition: "all 0.2s",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => e.currentTarget.style.opacity = "0.8"}
              onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
            />
            {!collapsed && (
              <div
                onClick={changeCollapsed}
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all 0.2s",
                  backgroundColor: "transparent",
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
              >
                <ChevronLeft size={20} color="#718096" />
              </div>
            )}
          </div>
          <Menu selectedKeys={[pathname]} mode="inline" items={items} />
        </WrapperSider>
        <Content
          style={{
            marginLeft: collapsed ? "80px" : "260px",
            transition: "margin-left 0.2s ease",
            width: "100%",
            backgroundColor: "#f4f6f9",
          }}
        >
          <div
            className="site-layout-background"
            style={{
              padding: "20px 24px",
              minHeight: 360,
              height: "calc(100vh - 64px)",
              overflow: "auto",
              scrollbarGutter: "stable",
            }}
          >
            {children}
          </div>
        </Content>
      </ContentLayout>
    </WrapperLayout>
  );
};
